import { Component, Input, TemplateRef, contentChild } from '@angular/core';

import { Mrt } from '@alan-apps/data-access';
import { input } from '@angular/core';

@Component({
  selector: 'ngx-google-map-link',
  templateUrl: './google-map-link.component.html',
  styleUrls: ['./google-map-link.component.scss'],
  standalone: true,
  imports: [],
})
export class GoogleMapLinkComponent {
  nameTemplateRef = contentChild<TemplateRef<any>>('name');

  location = input<Mrt | undefined>();
}
